import React from "react";

export default function Cable() {
  return <div>Service is currently Unavailable!</div>;
}
